import { render, staticRenderFns } from "./header-notification-area.vue?vue&type=template&id=f89ea1bc&scoped=true&"
import script from "./header-notification-area.vue?vue&type=script&lang=ts&"
export * from "./header-notification-area.vue?vue&type=script&lang=ts&"
import style0 from "./header-notification-area.vue?vue&type=style&index=0&id=f89ea1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89ea1bc",
  null
  
)

export default component.exports